// Mirrors IPS.Core.Enums.TranslationScope on the backend. Serialized as a plain
// number (no JsonStringEnumConverter is configured on the API), so the values
// must stay in sync with the backend enum's underlying ints.
export enum TranslationScope {
  Server = 0,
  Mobile = 1,
  Both = 2,
}

export interface ICulture {
  id: string;
  cultureCode: string;
  displayName: string;
  isActive: boolean;
  isBaseline: boolean;
  translationCount: number;
  modifiedAt?: string;
}

export interface ITranslationItem {
  key: string;
  value?: string;
  scope?: TranslationScope;
}

export interface ICultureTranslations {
  cultureId: string;
  cultureCode: string;
  displayName: string;
  translations: ITranslationItem[];
}
